import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import {
  Button,
  // Checkbox, 
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Box,
  Paper,
  Chip,
  Stack,
  IconButton,
  Divider
} from '@mui/material'
import { getDistribuicao } from '../../../utils/crm/getDistribuicao';
// import { getDiaSemana } from '../../../utils/crm/getDiaSemana';
import { getListOperadorEscala } from '../../../controllers/crm/operescalaController';
import { green, red } from '@mui/material/colors';
// import ReplayTwoToneIcon from '@mui/icons-material/ReplayTwoTone';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import { operadorStatus } from '../../../constants/crm';

export function ListarParticipantes({
  openParticipantes,
  setOpenParticipantes,
  escala,
  setSnackbar
}) {

  const [load, setLoad] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [operadores, setOperadores] = useState([])
  const [filterOperadores, setFilterOperadores] = useState([])
  const [todos, setTodos] = useState(true)

  const handleNo = () => {
    setOpenParticipantes(false);
  };

  // const handleCheck = (e) => {
  //   setTodos(!todos)
  //   if (e.target.checked) {
  //     setFilterOperadores(operadores.filter((corretor) => corretor.ordem > 0))
  //   } else {
  //     setFilterOperadores(operadores)
  //   }
  // }
  const isMobile = window.innerWidth < 600;

  async function loadOperadorescala() {
    setLoad(true)
    const dados = {
      idescala: escala.idescala,
    }
    const api = await getListOperadorEscala(dados)

    if (api.status !== 200) {
      setSnackbar({ severity: 'error', message: 'Falha ao carregar dados do operador!' });
      setLoad(false)
      return
    }
    else if (api.data) {
      setOperadores(api.data)
      setFilterOperadores(api.data)
      setLoad(false)
    }
  }

  useEffect(() => {
    if (openParticipantes) {
      loadOperadorescala()
    }
  }, [openParticipantes])

  // const participantesComOrdem = filterOperadores.filter(op => op.ordem > 0).length;
  // const participantesDisponiveis = filterOperadores.filter(op => op.status === operadorStatus.Disponivel).length;

  return (
    <Dialog
      maxWidth="md"
      open={openParticipantes}
      onClose={handleNo}
      fullScreen={window.innerWidth < 600}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: { xs: '100vh', sm: '500px' },
          maxHeight: { xs: '100vh', sm: '80vh' }
        }
      }}
    >
      {load && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 1000
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box flex={1}>
            <Typography variant="h5" component="div" fontWeight="bold" color="primary">
              Escala Online
            </Typography>
            <Typography variant="h5" sx={{ mt: 0.5, textTransform: 'capitalize' }}>
              {new Date(escala.diamesano).toLocaleDateString('pt-BR', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </Typography>
            <Box display="flex" alignItems="center" gap={1} mt={1}>
              <Chip
                label={getDistribuicao(escala.tpdistribuicao)}
                size="small"
                color="primary"
                variant="outlined"
              />
              <Chip
                icon={<AccessTimeIcon />}
                label={`${dayjs(escala.hrinicial).format('HH:mm')} - ${dayjs(escala.hrfinal).format('HH:mm')}`}
                size="small"
                variant="outlined"
              />
            </Box>
          </Box>
          <IconButton onClick={handleNo} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ px: 3, py: 2 }}>
        <Stack spacing={2}>
          {/* Controles e Estatísticas */}
          {/* <Paper elevation={1} sx={{ p: 2, backgroundColor: 'grey.50' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Box display="flex" alignItems="center" gap={1}>
                <Checkbox
                  checked={!todos}
                  onChange={handleCheck}
                  size="small"
                />
                <Typography variant="body2">
                  {!todos ? 'Todos Corretores' : 'Mostrar  Leads e Ordens'}
                </Typography>
              </Box>
              <IconButton
                onClick={loadOperadorescala}
                disabled={load}
                size="small"
                color="primary"
              >
                <ReplayTwoToneIcon />
              </IconButton>
            </Box>

            <Stack direction="row" spacing={2} flexWrap="wrap">
              <Chip 
                icon={<PersonIcon />}
                label={`${filterOperadores.length} Total`} 
                size="small" 
              />
              <Chip 
                icon={<LeaderboardIcon />}
                label={`${participantesComOrdem} Com Ordem`} 
                size="small"
                color="info"
              />
              <Chip 
                label={`${participantesDisponiveis} Disponíveis`} 
                size="small"
                sx={{ 
                  backgroundColor: green[100], 
                  color: green[800] 
                }}
              />
            </Stack>
          </Paper> */}

          {/* Lista de Participantes */}
          <Box>
            <Typography variant="h5" mb={2} display="flex" alignItems="center" gap={1}>
              <PersonIcon color="primary" />
              Participantes
            </Typography>

            {filterOperadores.length > 0 ? (
              <Paper
                variant="outlined"
                sx={{
                  maxHeight: '400px',
                  overflow: 'auto',
                  backgroundColor: 'grey.25'
                }}
              >
                <Stack spacing={1} p={1}>
                  {filterOperadores.map((corretor, i) => (
                    <Paper
                      key={i}
                      elevation={0}
                      sx={{
                        p: .5,
                        backgroundColor: corretor.status === operadorStatus.Disponivel
                          ? green[50]
                          : red[50],
                        border: `0.5px solid ${corretor.status === operadorStatus.Disponivel
                          ? green[200]
                          : red[200]}`,
                        '&:hover': {
                          boxShadow: 1
                        }
                      }}
                    >
                      <Grid container alignItems="center" spacing={2}>
                        {corretor.ordem && !isMobile && (
                          <Grid item xs="auto">
                            <Chip
                              label={corretor.ordem}
                              size="small"
                              color="primary"
                              sx={{ minWidth: '40px' }}
                            />
                          </Grid>
                        )}

                        <Grid item xs>
                          <Typography
                            variant="body1"
                            noWrap={isMobile}
                            sx={{
                              ...(isMobile && {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '150px'
                              })
                            }}
                            title={corretor.nome}
                          >
                            {corretor.nome}
                          </Typography>
                        </Grid>

                        {!isMobile && (
                          <Grid item xs="auto">
                            <Box display="flex" alignItems="center" gap={0.5}>
                              <AccessTimeIcon fontSize="small" color="action" />
                              <Typography variant="body2" color="text.secondary">
                                {dayjs(corretor.hio).format('HH:mm')} - {dayjs(corretor.hfo).format('HH:mm')}
                              </Typography>
                            </Box>
                          </Grid>
                        )}

                        { corretor.ordem && (
                          <Grid item xs="auto">
                            <Chip
                              label={`${corretor.qtd} leads`}
                              size="small"
                              variant="outlined"
                              color="info"
                            />
                          </Grid>
                        )}

                        <Grid item xs="auto">
                          <Chip
                            label={corretor.status === 'di' ? 'Ativo' : 'Inativo'}
                            size="small"
                            color={corretor.status === 'di' ? 'success' : 'error'}
                            variant="filled"
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  ))}
                </Stack>
              </Paper>
            ) : (
              <Paper variant="outlined" sx={{ p: 3, textAlign: 'center' }}>
                <PersonIcon sx={{ fontSize: 48, color: 'grey.400', mb: 1 }} />
                <Typography variant="body1" color="text.secondary">
                  Não há corretores cadastrados ou o Online não está em execução.
                </Typography>
              </Paper>
            )}
          </Box>
        </Stack>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          variant="contained"
          onClick={handleNo}
          disabled={disabled}
          size="small"
          sx={{ minWidth: '100px' }}

        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
